module.exports = {
    props: ['user'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                title: '',
                name: '',
                email: '',
                phone: '',
                birthday: '',
            }), Spark.forms.updateContactInformation),
            disabledDates: {
                from: new Date(), // Disable all dates after specific date
            }
        };
    },


    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.name = this.user.name;
        this.form.email = this.user.email;
        this.form.phone = this.user.phone;
        this.form.birthday = moment(this.user.birthday).local().format('MM/DD/yyyy');
        this.form.title = (this.user.title)? this.user.title:'';
    },


    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            Spark.put('/settings/contact', this.form)
                .then(() => {
                    Bus.$emit('updateUser');
                });
        },
        /**
         *To Format birthday date for Contact form.
         */
        fixDate(event){
            if(!moment(event).isValid()){
                if (event){
                    this.form.errors.errors.birthday = ["Not a valid date."];
                }else {
                    delete this.form.errors.errors.birthday
                }
                this.form.birthday = null;
            }else {
                delete this.form.errors.errors.birthday
                this.form.birthday = moment(event).local().format('MM/DD/yyyy');
            }
        },
    }
};
